import {createSlice} from '@reduxjs/toolkit'

import {RootState} from '../../store'

type MarketingNotificationsState = {
  shouldShowPopup: boolean
}

const initialState: MarketingNotificationsState = {
  shouldShowPopup: false
}

const marketingNotificationsSlice = createSlice({
  name: 'marketingNotifications',
  initialState,
  reducers: {
    showMarketingNotificationPopup(state) {
      state.shouldShowPopup = true
    },
    hideMarketingNotificationPopup(state) {
      state.shouldShowPopup = false
    }
  }
})

export const {showMarketingNotificationPopup, hideMarketingNotificationPopup} =
  marketingNotificationsSlice.actions

export const selectShouldShowMarketingNotificationPopup = (state: RootState) =>
  state.marketingNotifications.shouldShowPopup

export default marketingNotificationsSlice.reducer
